import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import vt from './vt';
import bnd from './bnd';
import btc from './btc';
import { BT_START, TIMEZONE } from '../config/constants';

let VT;
let BND;
let BTC;

const STOCK_TICKER_URL = 'https://coinfi-yahoo-finance.herokuapp.com/getQuotes';
// const STOCK_TICKER_URL = 'http://localhost:5000/getQuotes'; // development url
const COIN_TICKER_URL = 'http://postgrest.coinfi.com:3001/hourly_ohcl_prices?coin_key=eq.bitcoin.org&to_currency=eq.USD&order=time.asc';
const RETRIES = 10;

async function getYahooData() {
  for (let i = 0; i < RETRIES; i++) {
    let results = await axios.get(STOCK_TICKER_URL);

    if (typeof results.data === "undefined") {
      console.log("Could not get results from yahoo.");
      continue;
    }
  
    // TODO: rename vt throughout app to STK
    let vt = results.data.STK;
    let bnd = results.data.BND;

    if (
      typeof vt === "undefined" || typeof bnd === "undefined" ||
      vt.length <= 0 || bnd.length <= 0
    ) {
      console.log("Could not retrieve historical stock data!");
      continue;
    }

    return {vt, bnd};
  }
  
  return {};
}

async function getCoinFiData() {
  for (let i = 0; i < RETRIES; i++) {
    let results = await axios.get(COIN_TICKER_URL);

    if (typeof results.data === "undefined") {
      console.log("Call to CoinFi failed!");
      continue;
    }

    let btc = results.data;
    if (typeof btc === "undefined") {
      console.log("Could not retrieve historical bitcoin data!");
      continue;
    }

    return btc;
  }
  return undefined;
}

export async function loadTickerData() {
  try {
    let [results, btc] = await Promise.all([
      getYahooData(),
      getCoinFiData()
    ]);

    let { vt, bnd } = results;
    if (
      typeof vt === "undefined" || typeof bnd === "undefined" ||
      vt.length <= 0 || bnd.length <= 0
    ) {
      throw "Could not retrieve historical stock data!";
    }

    if (typeof btc === "undefined") {
      throw "Could not retrieve historical bitcoin data!";
    }

    // Data is currently known to be reverse chronological
    _.reverse(vt);
    _.reverse(bnd);

    // get rid of null dates
    let vt_empty = _.reduce(vt, (indexes, data, index) => {
      if (typeof data.close === "undefined" || data.close === null) {
        return [...indexes, index];
      } else {
        return indexes;
      }
    }, []);
    let bnd_empty = _.reduce(bnd, (indexes, data, index) => {
      if (typeof data.close === "undefined" || data.close === null) {
        return [...indexes, index];
      } else {
        return indexes;
      }
    }, []);
    let combined_empty = _.union(vt_empty, bnd_empty);

    _.pullAt(vt, combined_empty);
    _.pullAt(bnd, combined_empty);

    // massage stock data
    VT = _.map(vt, (data) => {
      let {date, close} = data;

      date = moment(date).tz(TIMEZONE);
      close = Number(close);

      return {
        date,
        close,
      };
    });
    BND = _.map(bnd, (data) => {
      let {date, close} = data;

      date = moment(date).tz(TIMEZONE);
      close = Number(close);

      return {
        date,
        close,
      };
    });

    // massage coin data
    BTC = _.map(btc, (data) => {
      let {timestamp, close} = data;

      let date = moment.unix(timestamp).tz(TIMEZONE);
      close = Number(close);

      return {
        date,
        close,
      };
    });

    // Filter out extra days (BTC chart has no days off)
    _.forEach(BND, (bond, index) => {
      let indexes = [];
      let i = index;
      while(i < BTC.length) {
        let coin = BTC[i];
        let comparison = coin.date.isSameOrAfter(bond.date, 'day');
        // console.log(index, i, bond.date.format('YYYY-MM-DD'), coin.date.format('YYYY-MM-DD'), comparison);
        if (comparison) {
          break;
        } else {
          // console.log(`adding ${i} to indexes`);
          indexes.push(i);
        }
        i++;
      }
      if (indexes.length > 0) {
        // console.log("pulling indexes " + JSON.stringify(indexes));
        _.pullAt(BTC, indexes);
      }
    });

    let dates = _.map(BND, bnd => bnd.date);

    return {
      VT,
      BND,
      BTC,
      dates,
    };
  } catch (error) {
    console.log(error);
    // return {};
    throw "Failed to load data.";
  }
}

// (async function() {
//   await loadTickerData();
//   console.log("Data loaded!");
// })();

export async function getHistoricalData() {
  return new Promise(resolve => {
    resolve({
      VT,
      BND,
      BTC,
    });
  })
}


// WEBPACK FOOTER //
// ./src/data/provider.js